import axios from "axios";
import React, { Component } from "react";
import {Container, Col, Row} from "react-bootstrap";

const initialState = {
    name: '',
    email: '',
    title: '',
    description: '',
    alertClass: '',
    alertText: '',
    messageSent: false
};
export class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }
    changeName = e => {
        this.setState({name: e.target.value});
    };
    changeEmail = e => {
        this.setState({email: e.target.value});
    };
    changeTitle = e => {
        this.setState({title: e.target.value});
    };
    changeDesc = e => {
        this.setState({description: e.target.value});
    };
    submitForm = (event) => {
        event.preventDefault();
        if (this.state.name === '' || this.state.email === '' || this.state.title === '' || this.state.description === '') {
            return;
        }

        let body = 'نام و نام خانوادگی:' + this.state.name + "\n" + this.state.description;

        (async () => {
            const result = await axios.post(
                process.env.REACT_APP_API_URL +
                    process.env.REACT_APP_ADD_MAIL,
                {
                    apiKey: process.env.REACT_APP_API_PUBLIC_TOKEN,
                    title: this.state.title,
                    email: this.state.email,
                    body: body
                }
            );

            if (result.data.result.status === true) {
                this.setState({
                    messageSent: true,
                    alertText: 'پیام با موفقیت ارسال گردید.',
                    alertClass: 'alert alert-success alert-dismissable',
                });
            } else {
                this.setState({
                    messageSent: true,
                    alertText: 'مشکلی در ارسال پیام رخ داد، لطفا دوباره امتحان کنید.',
                    alertClass: 'alert alert-danger alert-dismissable',
                });
            }
        })();

        let tempState = initialState;
        tempState.messageSent = true;
        this.setState(tempState);

        event.currentTarget.reset();

        setTimeout(() => this.setState({messageSent: false}), 4000)
    }

    render() {
        return (
            <section className="contact-crev section-padding pb-40">
                <Container>
                    <Row>
                        <Col lg={5}>
                            <div className="sec-lg-head mb-80">
                                <h2 className="fz-35 mb-35">با ما در ارتباط باشید</h2>
                                <p className="fz-15 mt-10">
                                    تهران، بزرگ‌راه حکیم شرق بعد از بزرگ‌راه ستاری، خروجی بهنام، جنب ایستگاه مترو شهید ستاری، پلاک یک - کدپستی: ۱۴۷۱۸۵۵۱۱۰
                                </p>
                                <div className="phone fz-20 fw-600 mt-15">
                                    <a href="tel:02142607000">021-42607000</a>
                                </div>
                                <div className="phone fz-20 fw-600 mt-15 color-blue">
                                    <a href="mailto:info@paidariranian.ir">info@paidariranian.ir</a>
                                </div>
                                <div className="phone fz-20 fw-600 mt-15 color-blue">
                                    <a href={"/"}>www.paidariranian.ir</a>
                                </div>
                                <ul className="rest social-text d-flex mt-60">
                                    <li className="mr-30">
                                        <a href="https://www.linkedin.com/company/%D8%B3%D8%B1%D9%85%D8%A7%DB%8C%D9%87-%DA%AF%D8%B0%D8%A7%D8%B1%DB%8C-%D8%B9%D9%85%D8%B1%D8%A7%D9%86-%D9%88-%D8%AA%D9%88%D8%B3%D8%B9%D9%87-%D9%BE%D8%A7%DB%8C%D8%AF%D8%A7%D8%B1-%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86">
                                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
                                                <path fill="#0078d4" d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5	V37z"> </path>
                                                <path d="M30,37V26.901c0-1.689-0.819-2.698-2.192-2.698c-0.815,0-1.414,0.459-1.779,1.364	c-0.017,0.064-0.041,0.325-0.031,1.114L26,37h-7V18h7v1.061C27.022,18.356,28.275,18,29.738,18c4.547,0,7.261,3.093,7.261,8.274	L37,37H30z M11,37V18h3.457C12.454,18,11,16.528,11,14.499C11,12.472,12.478,11,14.514,11c2.012,0,3.445,1.431,3.486,3.479	C18,16.523,16.521,18,14.485,18H18v19H11z" opacity=".05"> </path>
                                                <path d="M30.5,36.5v-9.599c0-1.973-1.031-3.198-2.692-3.198c-1.295,0-1.935,0.912-2.243,1.677	c-0.082,0.199-0.071,0.989-0.067,1.326L25.5,36.5h-6v-18h6v1.638c0.795-0.823,2.075-1.638,4.238-1.638	c4.233,0,6.761,2.906,6.761,7.774L36.5,36.5H30.5z M11.5,36.5v-18h6v18H11.5z M14.457,17.5c-1.713,0-2.957-1.262-2.957-3.001	c0-1.738,1.268-2.999,3.014-2.999c1.724,0,2.951,1.229,2.986,2.989c0,1.749-1.268,3.011-3.015,3.011H14.457z" opacity=".07"> </path>
                                                <path fill="#fff" d="M12,19h5v17h-5V19z M14.485,17h-0.028C12.965,17,12,15.888,12,14.499C12,13.08,12.995,12,14.514,12	c1.521,0,2.458,1.08,2.486,2.499C17,15.887,16.035,17,14.485,17z M36,36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698	c-1.501,0-2.313,1.012-2.707,1.99C24.957,25.543,25,26.511,25,27v9h-5V19h5v2.616C25.721,20.5,26.85,19,29.738,19	c3.578,0,6.261,2.25,6.261,7.274L36,36L36,36z"> </path>
                                            </svg>
                                        </a>
                                    </li>
                                    <li className="mr-30">
                                        <a href="https://instagram.com/enotpi?igshid=6dubtjusjp6j">
                                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
                                                <radialGradient id="yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1" cx="19.38" cy="42.035" r="44.899" gradientUnits="userSpaceOnUse">
                                                    <stop offset="0" stopColor="#fd5"> </stop>
                                                    <stop offset=".328" stopColor="#ff543f"> </stop>
                                                    <stop offset=".348" stopColor="#fc5245"> </stop>
                                                    <stop offset=".504" stopColor="#e64771"> </stop>
                                                    <stop offset=".643" stopColor="#d53e91"> </stop>
                                                    <stop offset=".761" stopColor="#cc39a4"> </stop>
                                                    <stop offset=".841" stopColor="#c837ab"> </stop>
                                                </radialGradient>
                                                <path fill="url(#yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1)" d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"> </path>
                                                <radialGradient id="yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2" cx="11.786" cy="5.54" r="29.813" gradientTransform="matrix(1 0 0 .6663 0 1.849)" gradientUnits="userSpaceOnUse">
                                                    <stop offset="0" stopColor="#4168c9"> </stop>
                                                    <stop offset=".999" stopColor="#4168c9" stopOpacity="0"> </stop>
                                                </radialGradient>
                                                <path fill="url(#yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2)" d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"> </path>
                                                <path fill="#fff" d="M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5	s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z"> </path>
                                                <circle cx="31.5" cy="16.5" r="1.5" fill="#fff"> </circle>
                                                <path fill="#fff" d="M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12	C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z"> </path>
                                            </svg>
                                        </a>
                                    </li>
                                    <li className="mr-30">
                                        <a href="https://t.me/enotpi">
                                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
                                                <path fill="#29b6f6" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"> </path>
                                                <path fill="#fff" d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z"> </path>
                                                <path fill="#b0bec5" d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z"> </path>
                                                <path fill="#cfd8dc" d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z"> </path>
                                            </svg>
                                        </a>
                                    </li>
                                    <li className="mr-30">
                                        <a href="https://www.aparat.com/enotpi">
                                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
                                                <path fill="#263238" d="M21.881 6.136l-4.315-.974c-3.52-.795-7.017 1.414-7.812 4.934l-.983 4.351C11.603 9.95 16.357 6.788 21.881 6.136zM6.136 26.119l-.974 4.315c-.795 3.52 1.414 7.017 4.934 7.812l4.351.983C9.95 36.396 6.788 31.643 6.136 26.119zM37.904 9.754l-4.351-.983c4.497 2.832 7.659 7.586 8.311 13.109l.974-4.315C43.633 14.047 41.424 10.549 37.904 9.754zM26.119 41.864l4.315.974c3.52.795 7.017-1.414 7.812-4.934l.983-4.351C36.397 38.05 31.643 41.212 26.119 41.864z"> </path>
                                                <path fill="#e91e63" d="M24,8C15.163,8,8,15.163,8,24s7.163,16,16,16s16-7.163,16-16S32.837,8,24,8z M20,13 c2.209,0,4,1.791,4,4c0,2.209-1.791,4-4,4s-4-1.791-4-4C16,14.791,17.791,13,20,13z M17,32c-2.209,0-4-1.791-4-4 c0-2.209,1.791-4,4-4s4,1.791,4,4C21,30.209,19.209,32,17,32z M22,24c0-1.105,0.895-2,2-2s2,0.895,2,2c0,1.105-0.895,2-2,2 S22,25.105,22,24z M28,35c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C32,33.209,30.209,35,28,35z M31,24 c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C35,22.209,33.209,24,31,24z"> </path>
                                            </svg>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                        <Col lg={6} className="offset-lg-1 valign">
                            <div className="full-width">
                                <form id="contact-form" onSubmit={this.submitForm}>

                                    {this.state.messageSent
                                    ? <div className="messages">
                                            <div className={this.state.alertClass}>
                                                <button type="button" className="close" data-dismiss="alert" aria-hidden="true"> &times; </button>
                                                {this.state.alertText}
                                            </div>
                                        </div>
                                    : <></>}

                                    <Row className="controls">

                                        <Col lg={6}>
                                            <div className="form-group mb-30">
                                                <input id="form_name" type="text" name="name" placeholder="نام"
                                                       onChange={this.changeName} required="required"/>
                                            </div>
                                        </Col>

                                        <Col lg={6}>
                                            <div className="form-group mb-30">
                                                <input id="form_email" type="email" name="email" placeholder="ایمیل"
                                                       onChange={this.changeEmail} required="required"/>
                                            </div>
                                        </Col>

                                        <div className="col-12">
                                            <div className="form-group mb-30">
                                                <input id="form_subject" type="text" name="title" placeholder="موضوع"
                                                       onChange={this.changeTitle} required='required'/>
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                            <textarea id="form_message" name="description" placeholder="پیام شما" rows="4"
                                                      onChange={this.changeDesc} required="required"> </textarea>
                                            </div>
                                            <div className="mt-30">
                                                <button type="submit" className="butn butn-md butn-bord radius-30">
                                                    <span className="text">ارسال</span>
                                                </button>
                                            </div>
                                        </div>

                                    </Row>
                                </form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        );
    }
}
